import {useQuery} from "react-query";
import {PostModel, PostPaginatedModel} from "./postTypes";
import {getAxios} from "../../axios/generic-api-calls";

export function useFetchPosts(currentPage: number, term: string, key: string = 'posts') {
    return useQuery<PostPaginatedModel>(
        [key, currentPage, term],
        () => getAxios(`/post?_page=${currentPage}&_limit=5&title_like=${term}`),
        {
            keepPreviousData: true,
            staleTime: 1000 * 60 * 5,
            cacheTime: 1000 * 60 * 10,
        }
    );
}

export function useFetchPostSlug(slug: string, key: string = 'post') {
    return useQuery<PostModel>(
        key,
        async () => (await getAxios(`/post?slug=${slug}`))[0],
        {
            keepPreviousData: true,
            staleTime: 1000 * 60 * 5,
            cacheTime: 1000 * 60 * 10,
        }
    );
}
